/** True when `NEXT_PUBLIC_UPHOLSTERY_PDM_V2_STRUCTURE=true` (Upholstery V2). */
export function isPdmStructureV2Enabled(): boolean {
  return (
    typeof process.env.NEXT_PUBLIC_UPHOLSTERY_PDM_V2_STRUCTURE === "string" &&
    process.env.NEXT_PUBLIC_UPHOLSTERY_PDM_V2_STRUCTURE.trim().toLowerCase() ===
      "true"
  )
}
